import VhrLink from './VhrLink';

export default VhrLink;
